import angular from 'angular';
import uiTooltip from 'angular-ui-bootstrap/src/tooltip';
import { NavbarComponent } from './navbar.component.js';
import { ProfilePictureComponent } from './profilePicture.component.js';
import { SideNavigation } from './navigation.directive.js';

const navbar = angular.module('navbar', [uiTooltip]);

navbar.component('navbar', NavbarComponent);
navbar.component('profilePicture', ProfilePictureComponent);
navbar.directive('sideNavigation', SideNavigation);

export { navbar };



// WEBPACK FOOTER //
// ./app/components/common/navbar/navbar.js